import { observer } from 'mobx-react'
import { useContext } from 'react'

import BaseOfferCard, { BaseOfferCardProps } from '@/components/redesign/offers/BaseOfferCard'
import { Bookings } from '@/types/types'
import { useTranslation } from '@/utils/hooks'
import StoresContext from '@/utils/StoresContext'

interface HighlightedOfferCardProps {
  offer: Bookings.Offer
  onOfferSelected?: () => void
}
const HighlightedOfferCard = observer(({ offer, onOfferSelected }: HighlightedOfferCardProps) => {
  const { translateField, t } = useTranslation()
  const { appStore } = useContext(StoresContext)
  const { toggleSelectedHighlightedOffer } = appStore
  const { isOfferExpired } = appStore.state
  const offerName = translateField(offer.name_translations)

  const getOfferTags = () => {
    const tags: BaseOfferCardProps['offerTags'] = []

    if (isOfferExpired(offer)) {
      tags.push({
        colorTheme: 'neutral',
        tag: t('offers.no_longer_available')
      })
    }
    return tags
  }

  const offerTags = getOfferTags()

  return (
    <BaseOfferCard
      offer={offer}
      offerName={offerName}
      offerTags={offerTags}
      isAvailable
      onCardClick={() => {
        toggleSelectedHighlightedOffer(offer)
        onOfferSelected?.()
      }}
      showTooltip={false}
    />
  )
})

export default HighlightedOfferCard
